import React from "react";
import i4 from "../components/Styles/assets/Graphics/Fitness.webp";

import MobileApplication from "../components/Styles/assets/Graphics/MobileApplication2.webp";
import LocalSEO2 from "../components/Styles/assets/Graphics/seo2.webp";
import SocialMedia from "../components/Styles/assets/Graphics/socialMedia2.webp";
import uiuxDesign from "../components/Styles/assets/Graphics/uiuxDesign3.webp";
import fitness1 from "../components/Styles/assets/Graphics/Fitness1.webp";
import fitness2 from "../components/Styles/assets/Graphics/Fitness2.webp";
import fitness3 from "../components/Styles/assets/Graphics/Fitness3.webp";
import fitness4 from "../components/Styles/assets/Graphics/Fitness4.webp";
import fitness5 from "../components/Styles/assets/Graphics/Fitness5.webp";
import fitness6 from "../components/Styles/assets/Graphics/Fitness6.webp";

import { StyledClient } from "../components/Styles";
import Consultation from "../components/Consultation";
import ClientHorizontalCard from "../components/ClientHorizontalCard";

import { useTranslation } from "react-i18next";

const images = {
  fitness1, fitness2, fitness3, fitness4, fitness5, fitness6, MobileApplication, LocalSEO2, SocialMedia, uiuxDesign
};

const GymFitness = () => {
  const { t, i18n } = useTranslation();

  const cardKeys = [
    "seoForFitness",
    "appAndWebsite",
    "onlineScheduling",
    "uiuxDesign",
    "socialMedia",
    "digitalMarketing"
  ];

  return (
    <StyledClient.Container>
      <StyledClient.Content>
        <StyledClient.ShapeTopLeft>
          <img src={i4} alt="Icon" />
        </StyledClient.ShapeTopLeft>
        <StyledClient.Title>
          <span>{t("gymFitness.heroSubtitle")}</span>
          {t("gymFitness.heroTitle")}
        </StyledClient.Title>

        <StyledClient.Description>
          {t("gymFitness.heroDescription")}
        </StyledClient.Description>
      </StyledClient.Content>

      <Consultation />

      <StyledClient.H3 lang={i18n.language}>{t("gymFitness.servicesTitle")}</StyledClient.H3>

      {cardKeys.map((key, index) => {
        const data = t(`gymFitness.cards.${key}`, { returnObjects: true });
        return (
          <ClientHorizontalCard
            key={index}
            title={data.title}
            subtitle={data.subtitle}
            visionPoints={data.visionPoints}
            missionPoints={data.missionPoints}
            icon={images[data.icon]}
          />
        );
      })}

      <Consultation />
    </StyledClient.Container>
  );
};

export default GymFitness;